<div class="inline-flex">
  <div class="hidden lg:flex items-center p-2" nz-dropdown nzTrigger="click" [nzDropdownMenu]="langMenu">
    <button
      type="button"
      class="inline-flex items-center gap-2 border-0 bg-transparent p-0 text-neutral-700"
      (click)="$event.preventDefault()"
    >
      <span nz-icon nzType="global" nzTheme="outline"></span>
      <span>{{ currentLanguageName }}</span>
      <span nz-icon nzType="down" nzTheme="outline"></span>
    </button>
    <nz-dropdown-menu #langMenu="nzDropdownMenu">
      <ul nz-menu class="max-h-120 overflow-y-auto">
        @for (language of languages; track language.code) {
          <li
            nz-menu-item
            [class.bg-primary-0]="language.code === currentLang"
            [class.font-semibold]="language.code === currentLang"
            (click)="onChangeLanguage(language.code)"
          >
            {{ language.name }}
          </li>
        }
      </ul>
    </nz-dropdown-menu>
  </div>

  <div class="flex lg:hidden items-center p-2">
    <ng-container *ngTemplateOutlet="selectLanguageTpl"></ng-container>
  </div>

  @if (!isDigitalServiceMenuMode && !hideSider) {
    <div class="flex items-center gap-1 p-1 lg:hidden">
      <button type="button" class="header-icon-button" (click)="onShowCartModal()">
        <span class="text-2xl leading-none !text-neutral-700" nz-icon nzType="shopping-cart" nzTheme="outline"></span>
        @if (cartItemsCount > 0) {
          <span
            class="cart-badge"
            [class.is-animating]="animateCartBadge"
            [class.is-removing]="animateCartBadgeReverse"
          >
            {{ cartItemsCount > 99 ? '99+' : cartItemsCount }}
          </span>
        }
      </button>
    </div>
  }
</div>

<ng-template #selectLanguageTpl>
  <span
    class="cursor-pointer text-xl !text-neutral-700"
    nz-icon
    nzType="global"
    nzTheme="outline"
    (click)="onShowLanguageModal()"
  ></span>
</ng-template>

<nz-modal
  [(nzVisible)]="languageModalVisible"
  nzWrapClassName="app-mobile-full-screen-modal"
  [nzFooter]="null"
  [nzCentered]="true"
  (nzOnCancel)="onHideLanguageModal()"
  [nzTitle]="'shared.footer.label-select-language' | translate"
>
  <ng-container *nzModalContent>
    <ul>
      @for (language of languages; track language.code) {
        <li class="mb-2 cursor-pointer" (click)="onChangeLanguage(language.code)">
          <nz-card
            nzSize="small"
            [class.bg-primary-0]="language.code === currentLang"
            [class.font-semibold]="language.code === currentLang"
          >
            {{ language.name }}
          </nz-card>
        </li>
      }
    </ul>
  </ng-container>
</nz-modal>

<nz-modal
  [(nzVisible)]="cartModalVisible"
  [nzFooter]="null"
  [nzClosable]="true"
  [nzCentered]="true"
  [nzTitle]="'components.cart-content.modal-title' | translate"
  (nzOnCancel)="onHideCartModal()"
>
  <ng-container *nzModalContent>
    @if (contentType === 'gift-card') {
      <app-gift-card-content [isModal]="true" (closeRequested)="onHideCartModal()"></app-gift-card-content>
    } @else {
      <app-cart-content [isModal]="true" (closeRequested)="onHideCartModal()"></app-cart-content>
    }
  </ng-container>
</nz-modal>
